import {
  Directive,
  ElementRef,
  OnInit,
  Optional,
  Renderer2,
  ViewContainerRef
} from '@angular/core';
import {ViewOnlyService} from "./view-only.service";

@Directive({
  selector: '[wellViewOnly]'
})
export class ViewOnlyDirective implements OnInit {

  disable = false;

  elementTypes = ['BUTTON', 'INPUT', 'SELECT'];

  el: ElementRef | undefined = undefined;

  constructor(@Optional() private viewOnlyService: ViewOnlyService,
              private viewContainerRef: ViewContainerRef,
              private renderer: Renderer2,
              private _el: ElementRef) {
    if (!viewOnlyService) {
      throw new Error('Provide ViewOnlyService!');
    }

    this.el = _el;
  }

  ngOnInit(): void {
    this.handleViewOnlyPage();
  }

  handleViewOnlyPage() {
    this.viewOnlyService.getIsViewOnly().subscribe(res => {
      this.disable = res;
      const element = this.getElement();
      this.applyViewOnly(element);
      const elementName = this.el?.nativeElement.nodeName;
      if (this.disable && !this.isFormElement(elementName)) {
        const elementClassName = this.el?.nativeElement.getAttribute('class');
        if (!(elementClassName && elementClassName.includes('active-solution-picker'))) {
          this.renderer.removeChild(this.el?.nativeElement.parentNode, this.el?.nativeElement);
        }
      }
    });
  }

  isFormElement(elementName: any) {
    return this.elementTypes.some((elementType) => elementName.includes(elementType));
  }

  getElement() {
    return this.el?.nativeElement;
  }

  applyViewOnly(element: any) {
    element.disabled = this.disable;
  }

}
